/**
 *
 * Asynchronously loads the component for SingleSelectFilter
 *
 */
import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
